import {advisorRoutes} from './advisorRoutes';
export const routes = {
  ...advisorRoutes,
  whichKindOfAuthIsAvailable: 'user/whichKindOfAuthIsAvailable?NID=',
  forgetPassword: 'user/forgetPassword',
  resetPassword: 'user/resetPassword',
  signIn: 'user/signIn',
  signup: 'user/signUp',
  setAboutMe: 'user/aboutMe',
  setMyFields: 'user/setMyFields',
  getMyCurrLevel: 'level/public/getMyCurrLevel',
  getTeacherProfile: 'user/getTeacherProfile/',
  getStudentProfile: 'profile/public/getUserProfile/',
  getStudentContents: 'profile/public/getUserContents/',
  getStudentComments: 'profile/public/getUserComments/',
  getStudentBadges: 'profile/public/getUserBadges/',
  getStudentQuizzes: 'profile/public/getUserQuizzes/',
  getStudentAdvisors: 'profile/public/getUserAdvisors/',
  getStudentTeachers: 'profile/public/getUserTeachers/',
  canReqForAdv: 'daily_adv/public/canReqForAdv',
  getRandAdv: 'daily_adv/public/getRandAdv',
  giveMyPointForAdv: 'daily_adv/public/giveMyPointForAdv',
  getCourseIntroduction: 'general/getCourseIntroduction/',
  getCourses: 'general/getCourses',
  fetchRSS: 'general/rss',
  buildSpinner: 'general/buildSpinner/',
  giveMyGift: 'general/giveMyGift',
  giveMyGifts: 'general/giveMyGifts',
  buildSpinnerAgain: 'general/buildSpinnerAgain/',
  checkCert: 'general/checkCert/',
  getMySummary: 'dashboard/getMySummary',
  exchange: 'general/exchange',
  exchangeOffers: 'exchange/public/getAll',
  getReward: 'exchange/public/getReward/',
  createOff: 'user/createOpenCardOff',
  activate: 'user/activate',
  resendCode: 'user/resendCode',
  updateInfo: 'user/updateInfo/',
  fetchUser: 'user/fetchUser/',
  getMyFields: 'user/getMyFields',
  getEducationalHistory: 'user/getEducationalHistory/',
  checkCode: 'user/checkCode',
  getMyRecps: 'user/myTransactions',
  getRoleForms: 'user/getRoleForms',
  sendRoleForm: 'user/sendRoleForm/',
  updateUsername: 'user/updateUsername/',
  setUsername: 'user/setNewUsername',
  changePass: 'user/changePassword/',
  logout: 'user/logout',
  getProfileConfig: 'profile/public/getMyConfig',
  setProfileConfig: 'profile/public/setMyConfig',
  fetchSiteStats: 'general/getSiteStats',
  fetchRankingList: 'general/getRankingList/',
  fetchFinishedQuizzes: 'quiz/public/getFinishedQuizzes',
  getLessonsDigest: 'admin/content/getLessonsDigest',
  fetchGradeLessons: 'admin/content/gradeLessons',
  fetchGradesAndBranches: 'admin/content/gradesAndBranches',
  fetchState: 'general/fetchStates',
  fetchGrades: 'admin/content/grades',
  fetchBranches: 'admin/content/branches',
  fetchNewAlerts: 'general/getNewAlerts',
  getMyAlerts: 'general/getMyAlerts',
  fetchSchoolsDigest: 'general/fetchSchoolsDigest',
  fetchContentDigests: 'general/fetchContentDigests',
  getTagsKeyVals: 'general/getTagsKeyVals',
  getQuestionAllFlags: 'general/getAllFlags',
  checkAvailableQuestions: 'general/checkAvailableQuestions',
  prepareCustomQuiz: 'quiz/public/prepareCustomQuiz',
  payCustomQuiz: 'quiz/public/payCustomQuiz/',
  uploadQuizAttaches: 'ckeditor/quiz',
  fetchIRYSCRegistrableQuizzes: 'quiz/public/get/irysc',
  fetchOpenQuizzes: 'quiz/public/get/open',
  resetEscapeQuiz: 'quiz/manage/resetEscapeQuiz/',
  fetchEscapeQuizRegistrableQuizzes: 'quiz/public/get/escape',
  setCorrectorByStudentMode: 'quiz/manage/setCorrectorByStudentMode/',
  setCorrectorByQuestionMode: 'quiz/manage/setCorrectorByQuestionMode/',
  toggleVisibilityQuiz: 'quiz/manage/toggleVisibility/',
  getQuizRecpForSchool: 'quiz/school/recp/',
  getHWRecpForSchool: 'quiz/school/recpHW/',
  copySchoolQuiz: 'quiz/school/copy/',
  getQuizTotalPriceForSchool: 'quiz/school/getTotalPrice/',
  getHWTotalPrice: 'quiz/school/getTotalHWPrice/',
  finalizeSchoolQuiz: 'quiz/school/finalize/',
  finalizeHW: 'quiz/school/finalizeHW/',
  setMarkHW: 'quiz/school/setMark/',
  getMyMarkListForSpecificStudent:
    'quiz/school/getMyMarkListForSpecificStudent/',
  getMyMarks: 'quiz/school/getMyMarks/',
  getMyMarkListForSpecificQuestion:
    'quiz/school/getMyMarkListForSpecificQuestion/',
  setMark: 'quiz/school/setMark/',
  getMyTasks: 'quiz/school/getMyTasks',
  getMyMarkList: 'quiz/school/getMyMarkList/',
  createQuiz: 'quiz/manage/store/',
  copyQuiz: 'quiz/manage/copy/',
  createHW: 'quiz/school/createHW',
  editHW: 'quiz/school/editHW/',
  changeArrangeQuestions: 'quiz/manage/arrangeQuestions/',
  finalizeQuizResult: 'quiz/manage/finalizeQuizResult/',
  fetchAllQuiz: 'quiz/manage/getAll/',
  fetchQuiz: 'quiz/manage/get/',
  fetchQuizTags: 'quiz/manage/getDistinctTags',
  editQuiz: 'quiz/manage/edit/',
  leftTeamQuiz: 'quiz/public/leftTeam/',
  buyQuiz: 'quiz/public/buy',
  buyOnlineQuiz: 'quiz/public/buyOnlineQuiz/',
  updateOnlineQuizProfile: 'quiz/public/updateOnlineQuizProfile/',
  fetchPackage: 'quiz/manage/getPackage/',
  getPackageBySlug: 'quiz/manage/getPackageBySlug/',
  groupBuyQuiz: 'quiz/public/groupBuy',
  fetchMyQuizzes: 'quiz/public/myQuizzes/',
  fetchMySchoolHWs: 'quiz/public/myHWs',
  getMyHW: 'quiz/public/myHW/',
  uploadHW: 'quiz/public/uploadHW/',
  downloadHW: 'quiz/public/downloadHW/',
  fetchMySchoolQuizzes: 'quiz/public/mySchoolQuizzes',
  fetchMyCustomQuizzes: 'quiz/public/myCustomQuizzes/',
  reviewQuiz: 'quiz/public/reviewQuiz/',
  rateQuiz: 'quiz/public/rate/',
  doQuiz: 'quiz/public/launch/',
  getMySubmits: 'quiz/public/getMySubmits/',
  getMyQuestionPDF: 'quiz/public/getMyQuestionPDF/',
  getMyAnswerSheetPDF: 'quiz/public/getMyAnswerSheetPDF/',
  storeStudentAnswers: 'quiz/public/storeAnswers/',
  storeOnlineQuizAnswer: 'quiz/public/storeOnlineQuizAnswer/',
  storeEscapeQuizAnswer: 'quiz/public/storeEscapeQuizAnswer/',
  getEscapeQuizGift: 'quiz/manage/getEscapeQuizGift/',
  addEscapeQuizGift: 'quiz/manage/addEscapeQuizGift/',
  removeEscapeQuizGift: 'quiz/manage/removeEscapeQuizGift/',
  getOnlineQuizRankingTable: 'quiz/public/getOnlineQuizRankingTable/',
  uploadStudentAnswers: 'quiz/public/uploadAnswers/',
  uploadStudentAnswersSheet: 'quiz/public/uploadAnswersSheet/',
  resetStudentQuizEntryTime: 'quiz/manage/resetStudentQuizEntryTime/',
  getLogs: 'quiz/manage/getLog/',
  fetchParticipantReport: 'quiz/report/participantReport/',
  fetchA1Report: 'quiz/report/A1/',
  fetchAuthorReport: 'quiz/report/authorReport/',
  fetchSchoolReport: 'quiz/report/schoolReport/',
  fetchKarnameReportExcel: 'quiz/report/getKarnameReportExcel/',
  fetchKarnameReport: 'quiz/report/karnameReport/',
  fetchCityReport: 'quiz/report/cityReport/',
  fetchStateReport: 'quiz/report/stateReport/',
  fetchGenderReport: 'quiz/report/genderReport/',
  fetchQuizAnswerSheet: 'quiz/manage/getQuizAnswerSheet/',
  fetchPDFQuizAnswerSheet: 'quiz/manage/getPDFQuizAnswerSheet/',
  fetchStudentAnswerSheet: 'quiz/manage/getStudentAnswerSheet/',
  addCorrector: 'quiz/manage/addCorrector/',
  fetchQuizCorrectors: 'quiz/manage/getCorrectors/',
  fetchQuizCorrector: 'quiz/manage/getCorrector/',
  fetchMyAnswerSheet: 'quiz/public/getMyAnswerSheet/',
  fetchQuizAnswerSheets: 'quiz/manage/getQuizAnswerSheets/',
  fetchQuizRanking: 'quiz/report/showRanking/',
  fetchQuizKarname: 'quiz/report/getStudentStat/',
  setQuizAnswerSheet: 'quiz/manage/setQuizAnswerSheet/',
  storeAnswers: 'quiz/manage/storeAnswers/',
  correct: 'quiz/manage/correct/10/2/30/70/4/',
  CVCorrect: 'correct/',
  createTaraz: 'quiz/manage/createTaraz/',
  transferToOpenQuiz: 'quiz/manage/createFromIRYSCQuiz/',
  updateQuestionMark: 'quiz/manage/updateQuestionMark/',
  removeQuiz: 'quiz/manage/remove/',
  removeIRYSCQuiz: 'quiz/manage/remove/irysc/',
  removeOpenQuiz: 'quiz/manage/remove/open/',
  removeSchoolQuiz: 'quiz/manage/remove/school/',
  generateQuestionPDF: 'quiz/manage/generateQuestionPDF/',
  getParticipants: 'quiz/manage/getParticipants/',
  removeQuestionFromQuiz: 'quiz/manage/removeQuestionFromQuiz/',
  forceRegistry: 'quiz/manage/forceRegistry/',
  onlineStandingForceRegistry: 'quiz/manage/onlineStandingForceRegistry/',
  onlineStandingAddMember: 'quiz/manage/onlineStandingAddMember/',
  onlineStandingChangeMainMember: 'quiz/manage/changeMainMember/',
  onlineStandingRemoveMember: 'quiz/manage/removeMember/',
  forceDeportation: 'quiz/manage/forceDeportation/',
  removeCorrectors: 'quiz/manage/removeCorrectors/',
  fetchQuestions: 'quiz/manage/fetchQuestions/',
  getPDFQuizQuestions: 'quiz/manage/getPDFQuizQuestions/',
  getPDFQuizSubjects: 'quiz/manage/getPDFQuizSubjects/',
  getPDFQuizInfo: 'quiz/manage/getPDFQuizInfo/',
  getGradesAndBranches: 'quiz/manage/getGradesAndBranches/',
  setPDFQuizQuestions: 'quiz/manage/setPDFQuizQuestions/',
  setPDFQuizSubjectsAndChoicesCount:
    'quiz/manage/setPDFQuizSubjectsAndChoicesCount/',
  setPDFQuizInfo: 'quiz/manage/setPDFQuizInfo/',
  setPDFQuizAnswerSheet: 'quiz/manage/setPDFQuizAnswerSheet/',
  addBatchQuestionsToQuiz: 'quiz/manage/addBatchQuestionsToQuiz/',
  addQuestionToQuizzes: 'quiz/manage/addQuestionToQuizzes/',
  fetchAllPackages: 'quiz/manage/getPackages',
  getPackagesByTag: 'quiz/manage/getPackagesByTag/',
  fetchAllPackagesDigest: 'quiz/manage/getPackagesDigest',
  fetchPackageQuizzes: 'quiz/manage/getPackageQuizzes/',
  removePackages: 'quiz/manage/removePackages',
  createPackage: 'quiz/manage/createPackage',
  updatePackage: 'quiz/manage/updatePackage/',
  getRecpForQuiz: 'quiz/public/getRecpForQuiz/',
  addFileToQuiz: 'quiz/manage/addAttach/',
  removeFileToQuiz: 'quiz/manage/removeAttach/',
  addQuizzesToPackage: 'quiz/manage/addQuizzesToPackage/',
  removeQuizzesFromPackage: 'quiz/manage/removeQuizzesFromPackage/',
  GetGeneralStats: 'admin/stats/report',
  addBatchSchoolQuestions: 'quiz/school/addBatchQuestions/',
  addBatchFiles: 'admin/general/uploadFiles/',
  fetchMyTickets: 'ticket/getMyRequests',
  submitTicket: 'ticket/submit',
  setAnswerTicket: 'ticket/setAnswer/',
  sendTicket: 'ticket/sendRequest/',
  addFileToTicket: 'ticket/addFileToRequest/',
  setAvatarAsMyPic: 'user/setAvatar/',
  blockNotif: 'user/blockNotif/',
  getAllConfiguration: 'admin/config/config/getAll',
  getShopConfiguration: 'admin/config/config/getShop',
  getCertConfiguration: 'admin/config/config/getCert',
  updateConfiguration: 'admin/config/config/update',
  createNewExchange: 'exchange/admin/store',
  getAllExchanges: 'exchange/admin/getAll',
  getAllBadges: 'badge/admin/getAll',
  getAllBadgesForPublic: 'badge/public/getAll',
  getAllPoints: 'point/admin/getAll',

  getActions: 'point/admin/getActions',
  getAllLevels: 'level/admin/getAll',

  getAllDailyAdvs: 'daily_adv/admin/getAll',
  fetchSchools: 'admin/config/school/fetchSchools',
  addSchool: 'admin/config/school/add',
  editSchool: 'admin/config/school/edit/',
  getAllAuthors: 'admin/config/author/get',
  getAuthorsKeyVals: 'admin/config/author/getAuthorsKeyVals',
  editAuthor: 'admin/config/author/edit/',
  removeAuthors: 'admin/config/author/remove',
  getAuthorTransactions: 'admin/config/author/getTransactions/',
  getAuthorLastTransaction: 'admin/config/author/getLastTransaction/',
  createAuthorTransaction: 'admin/config/author/addTransaction/',
  removeAuthorTransactions: 'admin/config/author/removeTransactions/',
  getGiftConfig: 'admin/config/gift/getConfig',
  getAllGift: 'admin/config/gift/get',
  giftReport: 'admin/config/gift/report',
  removeGift: 'admin/config/gift/remove',
  addGift: 'admin/config/gift/store',
  editGift: 'admin/config/gift/edit/',
  updateGiftConfig: 'admin/config/gift/updateConfig',
  checkDuplicate: 'admin/user/checkDuplicate',
  acceptInvite: 'admin/user/acceptInvite/',
  addSchoolByAgent: 'admin/user/addSchool',
  addExistSchoolByAgent: 'admin/user/addExistSchool',
  removeSchoolFormAgent: 'admin/user/removeSchools',
  getAllAgent: 'admin/user/getMySchools',
  fetchAllTarazLevels: 'admin/config/tarazLevel/get',
  createTarazLevel: 'admin/config/tarazLevel/create',
  updateTarazLevel: 'admin/config/tarazLevel/edit/',
  removeTarazLevels: 'admin/config/tarazLevel/remove',
  getAllStudent: 'admin/user/getStudents',
  addStudents: 'admin/user/addStudent',
  checkOffCode: 'general/checkOffCode',
  getTransactions: 'admin/transaction/get?',
  getMyOffs: 'general/myOffs',
  chargeAccount: 'general/chargeAccount/',
  setDisplayPriority: 'admin/user/setPriority/',
  fetchInvoice: 'general/fetchInvoice/',
  getQuestionTagsExcel: 'general/getQuestionTagsExcel',
  issueMyCert: 'certificate/issueMyCert/',
  issueCert: 'certificate/issueCert/',
  verifyCert: 'certificate/verifyCert/',
  getMyCerts: 'certificate/getMyCerts/',
  addCertificate: 'certificate/admin/store',
  editCertificate: 'certificate/admin/update/',
  setCertificateImg: 'certificate/admin/setImg/',
  getAllCertsDigest: 'general/getAllCertsDigest',
  getAllQuizzesDigest: 'general/getAllQuizzesDigest',
  getAllContentQuizzesDigest: 'general/getAllContentQuizzesDigest',
  getSubjectCodesExcel: 'general/getSubjectCodesExcel',
  getAuthorCodesExcel: 'general/getAuthorCodesExcel',
  addUserToCert: 'certificate/admin/addUserToCert/',
  editUserInCert: 'certificate/admin/editUserInCert/',
  getCertificate: 'certificate/admin/get/',
  fetchAllCertificate: 'certificate/admin/getAll',
  removeCertificate: 'certificate/admin/remove',
  removeStudentsFromCertificate: 'certificate/admin/removeStudents/',
  getTeacherContents: 'package_content/public/getTeacherContents/',
  rateContent: 'package_content/public/rate/',
  teacherPackages: teacher =>
    `package_content/public/teacherPackages?teacher=${teacher}`,
  fetchContents: 'package_content/public/getAll',
  fetchMyContents: 'package_content/public/getMy',
  fetchContent: 'package_content/public/get/',
  fetchSessions: 'package_content/public/getSessions/',
  getTeacherBio: 'package_content/public/getTeacherBio',
  getChapters: 'package_content/public/chapters/',
  fetchSessionInContent: 'package_content/manage/fetchSessions/',

  setSessionVideo: 'package_content/manage/setSessionVideo/',
  removeVideoFromSession: 'package_content/manage/removeVideoFromSession/',
  addٰAttachToSession: 'package_content/manage/addٰAttachToSession/',
  removeAttachFromSession: 'package_content/manage/removeAttachFromSession/',
  removeSessionFromContent: 'package_content/manage/removeSession/',
  changeTeacherName: 'package_content/public/changeTeacherName/',
  distinctTagsContents: 'package_content/public/distinctTags',
  buyContent: 'package_content/public/buy/',
  distinctTeachersContentsForAdmin:
    'package_content/public/distinctTeachersForAdmin',
  distinctTeachersContents: 'package_content/public/distinctTeachers',
  sessionVideoChunkFile: 'package_content/manage/sessionVideoChunkFile/',
  completeUploadSessionVideo:
    'package_content/manage/completeUploadSessionVideo/',

  setSeenNotif: 'notifs/setSeen/',
  fetchNotif: 'notifs/get/',
  addAttachToNotif: 'notifs/addAttach/',
  myNotifs: 'notifs/myNotifs',
  fetchAllNotifs: 'notifs/manage/getAll',
  getNotif: 'notifs/manage/get/',
  storeNotif: 'notifs/manage/store',
  simpleStoreNotif: 'notifs/manage/simpleStore',
  removeNotif: 'notifs/manage/remove/',
  getNotifStudents: 'notifs/manage/getStudents/',
  getQuestionReportTags: 'questionReport/manage/getAllTags',
  getQuestionReportSeen: 'questionReport/manage/setSeen/',
  getQuestionReportReports: 'questionReport/manage/getReports/',
  addQuestionReportTag: 'questionReport/manage/addTag',
  removeQuestionReportTags: 'questionReport/manage/remove',
  editQuestionReportTag: 'questionReport/manage/editTag/',

  getVisibleQuestionReportTags: 'questionReport/public/getAllTags',
  storeQuestionReport: 'questionReport/public/storeReport/',
  getAllTags: 'advisor/tag/getAllTags',
  getAllLife: 'advisor/tag/getAllLifeTags',
  getAllExamTags: 'advisor/tag/getAllExamTags',
  removeTag: 'advisor/tag/removeTags',
  removeLife: 'advisor/tag/removeLifeTags',
  removeExamTags: 'advisor/tag/removeExamTags',
  createTag: 'advisor/tag/createTag',
  editTag: 'advisor/tag/editTag/',
  createLifeTag: 'advisor/tag/createLifeTag',
  getAdvisorTransactions: 'advisor/tag/getAdvisorTransactions/',
  createExamTag: 'advisor/tag/createExamTag',

  exportPDF: 'advisor/public/exportPDF/',
  payAdvisorPrice: 'advisor/public/payAdvisorPrice/',
  getAllAdvisors: 'advisor/public/getAllAdvisors',
  getMyAdvisors: 'advisor/public/getMyAdvisors',
  getMyAdvisorHistory: 'advisor/public/myAdvisorHistory/',
  buyAdvisorQuiz: 'quiz/public/buyAdvisorQuiz/',
  getMySchedules: 'advisor/public/getMySchedules',
  getMySchedulesDigest: 'advisor/public/getMySchedulesDigest',
  getDistinctAdvisorsTags: 'advisor/public/getAdvisorTags',
  notifyAdvisorForSchedule: 'advisor/public/notifyAdvisorForSchedule/',

  getMyLessonsInSchedule: 'advisor/public/getMyLessonsInSchedule/',
  setDoneInSchedule: 'advisor/public/setDoneTime/',

  hasOpenRequest: 'advisor/public/hasOpenRequest',
  sendAdvisorAcceptanceRequest: 'advisor/public/request/',
  cancelAdvisor: 'advisor/public/cancel/',
  getMyCurrentRoom: 'advisor/public/getMyCurrentRoom',
  rateToAdvisor: 'advisor/public/rate/',
  myLifeStyle: 'advisor/public/myLifeStyle/',
  addItemToMyLifeStyle: 'advisor/public/addItemToMyLifeStyle',
  removeItemFromMyLifeStyle: 'advisor/public/removeItemFromMyLifeStyle',
  setMyExamInLifeStyle: 'advisor/public/setMyExamInLifeStyle',
  myAdvisorAcceptanceRequests: 'advisor/public/myRequests',
  cancelAdvisorRequest: 'advisor/public/cancelRequest/',

  setPic: 'user/setPic',
  getAllTeachers: 'teach/student/getTeachers',
  getDistinctTeacherTags: 'teach/student/getDistinctTags',

  getTeacherSchedules: 'teach/student/getSchedules/',
  sendTeachRequest: 'teach/student/submitRequest/',
  payForTeachSchedule: 'teach/student/payForSchedule/',
  prePayForSchedule: 'teach/student/prePayForSchedule/',
  myScheduleRequests: 'teach/student/myScheduleRequests',
  cancelTeachRequest: 'teach/student/cancelRequest/',
  getMyTeachSchedules: 'teach/student/getMySchedules',
  rateToTeachSchedules: 'teach/student/rateToSchedule/',
  getMyTeachScheduleReportProblems:
    'teach/student/getMyTeachScheduleReportProblems/',
  setMyTeachScheduleReportProblems:
    'teach/student/setMyTeachScheduleReportProblems/',
  getTeachAllReportTags: 'teach/student/getAllReportTags',
  getTeachReports: 'teach/student/getTeachReports',

  getComments: 'comment/public/getComments/',
  getTopComments: 'comment/public/getTopComments/',
  getTeacherMarkedComments: 'comment/public/getTeacherMarkedComments/',
  writeComments: 'comment/manage/write/',
  getMyComments: 'comment/manage/getMyComments',
  getCommentsAboutMe: 'comment/manage/getCommentsAboutMe',
  toggleCommentMarkedStatus: 'comment/manage/toggleCommentMarkedStatus/',
  removeMyComment: 'comment/manage/removeComment/',

  publicGetListOfPackageLevels: 'package_content/public/getListOfPackageLevels',

  getStudentDashboardConfig: 'dashboard/getConfig',
  setStudentDashboardConfig: 'dashboard/setConfig',

  getAdviceAllReportTags: 'advisor/public/getAllReportTags',
  setAdviceScheduleReportProblemsByStudent:
    'general/advice_tag_report/setAdviceScheduleReportProblemsByStudent/',
  setAdviceScheduleReportProblemsByAdvisor:
    'general/advice_tag_report/setAdviceScheduleReportProblemsByAdvisor/',
  toggleVideoBookmark: videoId => `public/video/toggleBookmark/${videoId}`,
  getVideo: videoSlug => `public/video/get/${videoSlug}`,
  videoList: 'public/video/list',
  likeOrDislike: videoId => `public/video/likeOrDislike/${videoId}`,
  getAdv: 'public/video/getAdv',
  videoDistinctTags: 'public/video/distinctTags',
  videoDistinctAuthors: 'public/video/distinctAuthors',
  setSeen: videoId => `public/video/setSeen/${videoId}`,
  userVideos: (author, pageIndex, needTotalSize) =>
    `public/video/userVideos/${author}?pageIndex=${pageIndex}&needTotalSize=${needTotalSize}`,
  userInfo: author => `public/video/userInfo/${author}`,
};
